export const costs = [
  'Sleepless nights translating complex battery concepts',
  'Improvised explanations from disorganized technical materials',
  "Disconnected colleagues who don't see battery technology relevance",
  'Weekends building technical references and performance analyses from scratch',
  'No clear answers when professionals ask technical questions',
];
